import { useCallback, useEffect, useRef, useState } from 'react';
import { Toast, type ToastProps } from '../components/ui';

type Tone = NonNullable<ToastProps['tone']>;

const SHOW_MS = 3000;

/** A short message over the screen that hides itself. Render `toast` once per page. */
export function useToast() {
  const [current, setCurrent] = useState<{ text: string; tone: Tone } | null>(null);
  const timer = useRef<number | null>(null);

  const show = useCallback((text: string, tone: Tone = 'neutral') => {
    if (timer.current !== null) window.clearTimeout(timer.current);
    setCurrent({ text, tone });
    timer.current = window.setTimeout(() => setCurrent(null), SHOW_MS);
  }, []);

  useEffect(
    () => () => {
      if (timer.current !== null) window.clearTimeout(timer.current);
    },
    [],
  );

  const toast = current ? (
    <Toast tone={current.tone} placement="fixed">
      {current.text}
    </Toast>
  ) : null;

  return { toast, show };
}
